// @flow

import React, { type Node, useState } from 'react';
import styled, { css } from 'styled-components';
import { ValuesBox } from './values-box';
import { useIncomingPayment, getMerchant } from '@tectonics/prs/incoming-payment';
import IconChevronDownSrc from './chevron-down.svg';
import { useDevice } from '../../../template/device';
import { TotalValue } from './total-value';
import { getName as getMerchantName, getMerchantLogo } from '@tectonics/prs/merchant';

export function ValuesDisplay(): Node {
  const incomingPayment = useIncomingPayment();
  const device = useDevice();
  const [toggleValue, setToggleValue] = useState(device === 'desktop');
  const merchant = getMerchant(incomingPayment);
  const merchantLogo = getMerchantLogo(merchant);

  return (
    <ValuesDisplayWrapper desktop={device === 'desktop'}>
      <ValuesDisplayContentWrapper desktop={device === 'desktop'}>
        <Header
          onClick={() => device === 'mobile' && setToggleValue(!toggleValue)}
          desktop={device === 'desktop'}
          hasLogo={Boolean(merchantLogo)}
        >
          {merchantLogo ? (
            <MerchantIconWrapper desktop={device === 'desktop'}>
              <MerchantIcon
                src={merchantLogo}
                desktop={device === 'desktop'}
                alt={merchant.name}
              />
            </MerchantIconWrapper>
          ):(
            <CheckoutTitle desktop={device === 'desktop'}>
              {getMerchantName(getMerchant(incomingPayment))}
            </CheckoutTitle>
          )}
          <ValueBoxButton data-testid="value_box_button">
            <ToggleButton hide={device === 'desktop'}>
              <TotalValue />
              <ChevronDown up={toggleValue} />
            </ToggleButton>
          </ValueBoxButton>
        </Header>

        <ValuesBoxWrapper collapsed={!toggleValue} desktop={device === 'desktop'}>
          <ValuesBox/>
        </ValuesBoxWrapper>
      </ValuesDisplayContentWrapper>
    </ValuesDisplayWrapper>
  );
}

const ValuesDisplayWrapper = styled.div`
  margin: 0;
  width: 100%;
  ${props => props.desktop && css`
    padding-left: 4vw;
    padding-top: 10vh;
  `}
`;

const ValuesDisplayContentWrapper = styled.div`
  width: 100%;
  ${props => props.desktop && css`
    width: 350px;
  `}
`;

const ValuesBoxWrapper = styled.div`
  border-top: solid 1px #eeeeee;
  transition: max-height 200ms ease-in-out;
  overflow: hidden;
  max-height: 262px;
  ${props => props.collapsed && css`
    max-height: 0;
  `}
  ${props => props.desktop && css`
    overflow: visible;
  `}
`;

export const ValueBoxButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #738093;
  font-weight: 700;
  font-size: 21px;
  font-family: ${props => props.theme.fontFamily.display};
`;

export const ToggleButton = styled.div`
  display: flex;
  flex-direction: column wrap;
  justify-content: center;
  align-items: center;
  ${props => props.hide && css`
    display: none;
  `}
`;

export const ChevronDown = styled.span`
  display: inline-block;
  height: 9px;
  width: 14px;
  background-image: url(${IconChevronDownSrc});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-left: 10px;
  transition: transform 200ms ease;
  ${props => props.up && css`
      transform: rotateX(180deg);
  `}
`;

const MerchantIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 120px;
  margin-right: 1em;

  ${props => props.desktop && css`
    max-width: 160px;
  `}
`;

export const MerchantIcon = styled.img`
  height: auto;
  width: auto;
  max-height: ${props => props.desktop ? '42px' : '32px'};
  max-width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
  height: 84px;
  ${props => props.desktop && css`
    ${props => !props.hasLogo && css`
      height: 24px;
    `}
    padding: 0 0 15px 0;
  `}
`;

export const CheckoutTitle = styled.h1`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #738093;
  font-weight: 700;
  font-size: 21px;
  ${props => props.desktop && css`
    display: none;
  `}
`;
